<template>
  <a-modal
    title="修改支付密码"
    okText="提交"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <!-- 内容 -->
    <div class="detail-content">
      <!-- 原密码 -->
      <a-row>
        <a-col :span="leftSpan" class="modal-title">原密码：</a-col>
        <a-col :span="rightSpan" class="modal-desc">
          <a-input
            v-model.trim="passwordOld"
            placeholder="请输入"
            :disabled="confirmLoading"
          ></a-input>
        </a-col>
      </a-row>
      <!-- 新密码 -->
      <a-row>
        <a-col :span="leftSpan" class="modal-title">新密码：</a-col>
        <a-col :span="rightSpan" class="modal-desc">
          <a-input
            v-model.trim="password"
            placeholder="6 位数字，不可连续"
            :disabled="confirmLoading"
          ></a-input>
        </a-col>
      </a-row>
      <!-- 确认密码 -->
      <a-row>
        <a-col :span="leftSpan" class="modal-title">确认密码：</a-col>
        <a-col :span="rightSpan" class="modal-desc">
          <a-input
            v-model.trim="passwordTwo"
            placeholder="再输入一次"
            :disabled="confirmLoading"
          ></a-input>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import { modifyMobilePassword } from '@/api/hp-request'
export default {
  data () {
    return {
      leftSpan: 5,
      rightSpan: 19,
      // 显示/加载
      visible: false,
      confirmLoading: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      // 旧密码
      passwordOld: undefined,
      // 新密码
      password: undefined,
      passwordTwo: undefined
    }
  },
  methods: {
    // 显示
    showModal () {
      // 显示
      this.visible = true
      // 清空
      this.password = undefined
      this.passwordTwo = undefined
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        this.visible = false
      }
    },
    // 提交
    onSubmit () {
      // 检查密码是否为空
      if (!this.password || !this.passwordTwo || !this.passwordOld) {
        this.$message.error('密码不能为空')
        return 
      }
      // 检查密码是否一致
      if (this.password !== this.passwordTwo) {
        this.$message.error('密码不一致')
        return 
      }
      // 检查密码位数
      if (!/^\d{6}$/.test(this.password)) {
        this.$message.error('密码长度固定 6 位')
        return 
      }
      // 密码全部一样
      if (/^(\d)\1+$/.test(this.password)) {
        this.$message.error('密码过于简单')
        return 
      }
      // 顺增
      var str = this.password.replace(/\d/g, function($0, pos) { return parseInt($0) - pos })
      if (/^(\d)\1+$/.test(str)) {
        this.$message.error('密码过于简单')
        return 
      }
      // 顺减
      var str = this.password.replace(/\d/g, function($0, pos) { return parseInt($0) + pos }) 
      if (/^(\d)\1+$/.test(str)) {
        this.$message.error('密码过于简单')
        return 
      }
      // 提交
      this.confirmLoading = true
      const params = {
        old_wx_pay_password: this.passwordOld,
        wx_pay_password: this.password,
        re_wx_pay_password: this.passwordTwo
      }
      modifyMobilePassword(params).then(res => {
        this.confirmLoading = false
        const { code, message } = res
        if (code === 0) {
          this.$message.success('修改密码成功')
          this.handleCancel()
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.confirmLoading = true
        this.$message.error('修改密码失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-content {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}
.detail-content .ant-row:not(:first-child) {
  margin-top: 14px;
}
.modal-title {
  line-height: 32px;
  text-align: right;
}
.modal-desc {
  line-height: 32px;
}
.desc-info {
  width: 100%;
  background-color: #FAFAFA;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
}
.desc-info {
  margin-top: 14px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  line-height: 24px;
}
.modal-input {
  width: 136px;
}
</style>